module.exports = __webpack_public_path__ + "img/lw-icon.c021f7fc.png";